export const MAXIMUM_GIF_INPUT_FILESIZE = Math.pow(2, 20); // ~1Mb
export const MAXIMUM_GIF_AVATAR_FILESIZE = 102400;
export const MAXIMUM_AVATAR_FILESIZE = 20480;

export const AVATAR_SIZE = 100;
